<script setup lang="ts">
import VehicleCard from '~/components/vehicle/vehicle-card/VehicleCard.vue'
import { translate } from '~/composables/translate/translations'
import { useOfferStore } from '~/stores/offer'
import { useVehiclesStore } from '~/stores/vehicles'

const { isWebview = false } = defineProps<{ isWebview?: boolean }>()
const offerStore = useOfferStore()
const vehiclesStore = useVehiclesStore()
const { getAllBuildSeries } = vehiclesStore

onMounted(() => {
  // Always set the selectedOffer when the component is mounted
  // This ensures the scrolling animation happens every time
  if (offerStore.possibleOffers.length > 0) {
    const middleIndex = Math.floor(offerStore.possibleOffers.length / 2)
    // Force a new reference to trigger reactivity
    const selectedOffer = offerStore.possibleOffers[middleIndex]
    offerStore.selectedOffer = { ...selectedOffer }
  }
})

const translatedHeadline = computed(() => translate('headline_car_category'))
</script>

<template>
  <section>
    <h3 v-if="!isWebview" class="mb-24 text-black-100">
      {{ translatedHeadline }}
    </h3>
    <h4 v-else class="mb-24 text-black-100">
      {{ translatedHeadline }}
    </h4>
    <article v-if="!isWebview" class="flex flex-col space-y-[24px] md:space-y-0 md:grid md:grid-cols-2 md:gap-[24px] lg:grid-cols-3">
      <VehicleCard
        v-for="buildSeries in getAllBuildSeries()"
        :id="buildSeries"
        :key="buildSeries"
        :build-series="buildSeries"
        :data-testid="buildSeries"
      />
    </article>
    <article v-if="isWebview" class="flex flex-col space-y-[24px] w-full">
      <WebviewVehicleCard
        v-for="buildSeries in getAllBuildSeries()"
        :id="buildSeries"
        :key="buildSeries"
        class="scroll-mt-[40%] scroll-mb-[200px]"
        :build-series="buildSeries"
        :data-testid="buildSeries"
      />
    </article>
  </section>
</template>
